<script setup lang="ts">
import DecorIcon from "#ui/primitives/decorIcon/DecorIcon.vue";
import type { CartCommentControl } from "../cartControls";

defineProps<{ control: CartCommentControl }>();
</script>

<template>
	<button type="button" class="cart_icon_button" :disabled="control.disabled" :aria-label="control.label" @click="control.toggle">
		<DecorIcon :icon="control.icon" :fallback="control.fallback" />
	</button>
</template>
